import React from 'react';
import OwlCarousel from 'react-owl-carousel2';
// import "react-owl-carousel2/src/owl.theme.default.css";
import Producto from './item-producto';
import 'react-owl-carousel2/lib/styles.css'; // Allows for server-side rendering.

import './index-productos.css';

function createSkeleton() {
  return (
    <>
      <div className='col-md-3'>
        <div className='content-item'>
          <h1 className='text-center'><span style={{ color: '#eaeaea' }}>&nbsp;</span></h1>
        </div>
      </div>
      <div className='col-md-3'>
        <div className='content-item'>
          <h1 className='text-center'><span style={{ color: '#eaeaea' }}>&nbsp;</span></h1>
        </div>
      </div>
      <div className='col-md-3'>
        <div className='content-item'>
          <h1 className='text-center'><span style={{ color: '#eaeaea' }}>&nbsp;</span></h1>
        </div>
      </div>
      <div className='col-md-3'>
        <div className='content-item'>
          <h1 className='text-center'><span style={{ color: '#eaeaea' }}>&nbsp;</span></h1>
        </div>
      </div>
    </>
  );
}

const options = {
  items: 10,
  dots: false,
  rtl: false,
  autoplay: false,
  margin: 20,
  nav: true,
  responsive: {
    0: {
      // navText: ["‹", "›"],
      nav: false,
      autoplay: true,
      autoplayTimeout: 3000,
      autoplayHoverPause: true,
      items: 1,
      dots: false,
      margin: 10,
      stagePadding: 20,
    },
    480: {
      //navText: ["<i class='fa fa-angle-left' aria-hidden='true'></i>", "<i class='fa fa-angle-right' aria-hidden='true'></i>"],
      nav: false,
      autoplay: true,
      autoplayTimeout: 3000,
      autoplayHoverPause: true,
      dots: false,
      items: 2,
      margin: 10,
      stagePadding: 20,
    },
    768: {
      navText: ["<i class='fa fa-angle-left' aria-hidden='true'></i>", "<i class='fa fa-angle-right' aria-hidden='true'></i>"],
      items: 4,
    },
    1500: {
      navText: ["<i class='fa fa-angle-left' aria-hidden='true'></i>", "<i class='fa fa-angle-right' aria-hidden='true'></i>"],
      items: 4,
    },
    2000: {
      navText: ["<i class='fa fa-angle-left' aria-hidden='true'></i>", "<i class='fa fa-angle-right' aria-hidden='true'></i>"],
      items: 4,
    },
  },
};
const events = {};

const IndexProductos = ({ data, uniqueId, fatherKey, voucherData }) => {
  if (!data) return createSkeleton();

  return (
    <div className='container-carousel'>
      <OwlCarousel
        id={uniqueId}
        options={options}
        events={events}
      >
        {data.map((prod) => (
          <Producto
            key={`${fatherKey}-product-${prod.id}`}
            data={prod}
            voucherData={voucherData}
          />
        ))}
      </OwlCarousel>
    </div>
  );
};

export default IndexProductos;
